/** A scheme in authority form — `scheme://…` (http, https, ftp, custom). */
const HAS_AUTHORITY_SCHEME = /^[a-z][a-z0-9+.-]*:\/\//i;

/**
 * No-authority schemes, enumerated. A regex can't tell `mailto:1@x` or
 * `tel:0398…` from a `host:8080` port, so the scheme forms without `//` are
 * listed explicitly: the safe ones so they keep working, the dangerous ones
 * (`javascript:`, `data:`) so they reach `setLink` unchanged and get rejected
 * rather than mangled into a passing `https://…` href.
 */
const KNOWN_SCHEME =
  /^(?:mailto|tel|callto|sms|cid|xmpp|data|javascript|vbscript|blob|file):/i;

/** Href forms that are deliberately relative to the current page. */
const IS_PAGE_RELATIVE = /^[/#?]/;

/**
 * Prefixes `https://` onto a bare host so it resolves absolutely.
 *
 * `setLink` stores whatever it is given — `defaultProtocol` only applies to
 * autolink/paste detection, never to an explicit href — so `heidihealth.com`
 * would resolve against the session URL, and `pacs-server:8080` would be stored
 * as a bogus `pacs-server:` protocol. Both navigate nowhere.
 *
 * Anything already carrying a real scheme (authority-form or a known
 * no-authority scheme) or a page-relative reference is returned untouched.
 */
export const normalizeLinkHref = (href: string): string => {
  const trimmed = href.trim();

  if (
    !trimmed ||
    IS_PAGE_RELATIVE.test(trimmed) ||
    HAS_AUTHORITY_SCHEME.test(trimmed) ||
    KNOWN_SCHEME.test(trimmed)
  ) {
    return trimmed;
  }

  return `https://${trimmed}`;
};
